import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { useIntl } from "react-intl";
import { Outlet } from "react-router";
import { useToast } from "hooks";
import { Grid, PageWrapper } from "components/Containers";
import { UserSettingsTitle } from "components/Settings/Users";

/**
 * UserSettings
 *
 * @param {Object} flash
 */
const UserSettings = ({ flash }) => {
  const intl = useIntl();

  useToast(flash);

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage({ id: "Meta.UserSettings.Title" })}</title>
      </Helmet>

      <UserSettingsTitle asHeader />

      <PageWrapper>
        <Grid topMargin>
          <Grid.col start={1} end={8}>
            <Outlet />
          </Grid.col>
        </Grid>
      </PageWrapper>
    </>
  );
};

UserSettings.propTypes = {
  flash: PropTypes.object,
};

export default UserSettings;
